import EarningsReportRenderer from '@app/components/EarningsReportRenderer'
import { ICurrentUserState } from '@app/store/modules/account'
import { IGlobalSocialNetworksState } from '@app/store/modules/global'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import {
  actionCreators,
  IConnectionViewState,
} from '../modules/connectionView'

interface IConnectionViewRouterProps {
  id: string
}

type IComponentProps = IConnectionViewState &
  ICurrentUserState &
  IGlobalSocialNetworksState &
  RouteComponentProps<IConnectionViewRouterProps> &
  typeof actionCreators

class ConnectionEarnings extends React.PureComponent<IComponentProps> {
  public constructor(props: any) {
    super(props)
  }

  public render() {
    return <div>{this._renderEarnings()}</div>
  }

  private _renderEarnings() {
    return (
      <div>
        <EarningsReportRenderer reportData={this.props.earnings} />
      </div>
    )
  }
}

export default withRouter(ConnectionEarnings)
